export default __webpack_public_path__ + "static/media/screen5.d8d01e57.png";